'use client';

import { getVillagesOld } from '@/actions/villages';
import Map from '@/components/Map';
import { VillageCardDictonary } from '@/components/VillageCard/Root';
import { SearchParams } from '@/components/VillagesWrapper';
import VillagesList from '@/components/VillagesWrapper/List';
import { cn } from '@/lib/utils';
import { getTranslatedRegion } from '@/utils/getTranslatedRegion';
import { useQueries } from '@tanstack/react-query';
import { useParams } from 'next/navigation';

type Props = {
  dicts: VillageCardDictonary;
  currency?: string;
  villagesCount: number;
  searchParams: SearchParams;
};

// function getRegionId(region: string): string | undefined {
//   const translatedRegion = getTranslatedRegion(region);

//   if (translatedRegion === 'sicily') {
//     return '1';
//   } else if (translatedRegion === 'puglia') {
//     return '2';
//   }
// }

const useGetVillages = ({
  searchParams,
  villagesCount,
}: {
  searchParams: SearchParams;
  villagesCount: number;
}) => {
  // const lang = useLocale();
  // const params = useParams();
  // const regionId = getRegionId(params.region as string);
  // const searchParams = useSearchParams();

  // const zoneId = searchParams.get('location') ?? undefined;
  // const adults = searchParams.get('adults') ?? undefined;
  // const children = searchParams.get('children') ?? undefined;
  // const infants = searchParams.get('infants') ?? undefined;
  // const sleeps = searchParams.get('sleeps') ?? undefined;
  // const startDate = searchParams.get('startDate') ?? undefined;
  // const endDate = searchParams.get('endDate') ?? undefined;

  // const queryParams: GetVillagesParams = {
  //   lang,
  //   regionId,
  //   catalogId,
  //   zoneId,
  //   adults,
  //   children,
  //   infants,
  //   sleeps,
  //   startDate,
  //   endDate,
  // };

  const countArr = Array.from(Array(Math.ceil(villagesCount / 9)).keys());

  return useQueries({
    queries: countArr.map((i) => ({
      queryKey: ['villages', searchParams, i],
      queryFn: () =>
        getVillagesOld({
          ...searchParams,
          offset: 9 * i,
        }),
      refetchOnWindowFocus: false,
      refetchInterval: 60 * 60 * 1000,
    })),
    combine: (results) => ({
      data: results
        .map((result) => (result.data ? result.data.data : []))
        .flat(),
      isPending: results.some((result) => result.isPending),
    }),
  });

  // return useQuery({
  //   queryKey: ['villages', searchParams, villagesCount],
  //   queryFn: () =>
  //     getVillagesOld({
  //       ...searchParams,
  //       offset: 9 * 0,
  //     }),
  //   refetchOnWindowFocus: false,
  //   refetchInterval: 60 * 60 * 1000,
  // });
};

export function MapContainer({
  dicts,
  currency,
  villagesCount,
  searchParams,
}: Props) {
  const { data, isPending } = useGetVillages({
    searchParams,
    villagesCount,
  });

  const params = useParams();
  const translatedRegion = getTranslatedRegion(params.region as string);

  if (isPending || !data) {
    return <Map.Loader />;
  }

  return (
    <>
      <VillagesList
        dicts={{
          regionZoneDict: dicts.regionZoneDict,
          currencyDict: dicts.currencyDict,
          villageDict: dicts.villageDict,
        }}
        isLoadingWithMap={isPending}
        villages={data}
        showMap={true}
        currency={currency}
      />
      <div
        id="map-root"
        className={cn(
          'hidden desktop:block h-full pb-[1.875rem] z-10 relative top-0 [&.is-sticky]:desktop:sticky [&.is-sticky]:desktop:top-[200px] flex-[2]',
        )}>
        <Map.Root
          customCenter={
            translatedRegion === 'puglia'
              ? {
                  lat: 41.0608651,
                  lng: 15.9659781,
                }
              : undefined
          }
          villages={data}
        />
      </div>
    </>
  );
}
